import { render, staticRenderFns } from "./text_right_video_left.vue?vue&type=template&id=4c869eb4&scoped=true&"
import script from "./text_right_video_left.vue?vue&type=script&lang=js&"
export * from "./text_right_video_left.vue?vue&type=script&lang=js&"
import style0 from "./text_right_video_left.vue?vue&type=style&index=0&id=4c869eb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c869eb4",
  null
  
)

component.options.__file = "text_right_video_left.vue"
export default component.exports